export default "__VITE_PUBLIC_ASSET__28bdf446__"